import { ReactElement } from 'react'
import { CartProduct } from 'cart'
import { ProductLocationModel } from 'interfaces'
import { LocationType } from '../../../helpers/locationType'
import styled from 'styled-components'
import { I18n, Translate } from 'common'
import { Tooltip } from '../../../ui-components/util/MUITooltipCustomization'
import WarningLabel from '../../WarningLabel'
import {
  hasNonPrimaryLocationError,
  hasOutOfStockError,
} from './AvailabilityErrors/utlis'

interface Props {
  product: CartProduct
  activeLocation: ProductLocationModel
  validatePrimaryLocation?: boolean
}

const LocationWarning = (props: Props): ReactElement => {
  const { product, activeLocation, validatePrimaryLocation } = props

  const nonPrimaryLocSelected = activeLocation?.locationId?.toString() !== '100'

  const productHasNonPrimaryLocationError =
    hasNonPrimaryLocationError(product) && validatePrimaryLocation

  const productIsOutOfStock = hasOutOfStockError(product)

  const tooltipMessage = Translate('delayedDeliveryDisclaimer')

  const delayedContent = (
    <Delayed>
      <I18n name="deliveryMayBeDelayed" />
      <Tooltip
        title={tooltipMessage}
        placement="left"
        arrow
        enterTouchDelay={0}
        leaveTouchDelay={5000}
      >
        <LearnMore>
          <I18n name="learnMore" />
        </LearnMore>
      </Tooltip>
    </Delayed>
  )

  switch (true) {
    case productIsOutOfStock:
      return (
        <WarningLabel name="deliveryMayBeDelayed" content={delayedContent} />
      )

    case (productHasNonPrimaryLocationError || nonPrimaryLocSelected) &&
      activeLocation.locType !== LocationType?.ORDER_FROM_PRIMARY:
      return <WarningLabel name="notPrimaryLocation" />

    case activeLocation.locType === LocationType?.ORDER_FROM_PRIMARY:
      return <WarningLabel name="ProcessedByLocalStore" />

    default:
      return null
  }
}

const Delayed = styled.div`
  font-size: 14px;
  font-weight: normal;
`

const LearnMore = styled.span`
  margin-left: 0.1rem;
  text-transform: capitalize;
  text-decoration: underline;
`

export default LocationWarning
